"use client";

import { Information } from "@faire/slate-icons/Information";
import { Button } from "@faire/slate/components/button";
import { ButtonBase } from "@faire/slate/private/button/ButtonBase";
import { ButtonIcon } from "@faire/slate/private/button/ButtonIcon";
import { useFloatingContext } from "@faire/slate/private/floating/FloatingContext";
import React from "react";

import { useFilterMenuContext } from "./FilterMenuContext";
import type { IFilterMenuTitleTriggerProps } from "./types";

type IProps = {
  clearActionLabel?: string;
  title: string;
  titleTriggerProps?: IFilterMenuTitleTriggerProps;
};

export const FilterMenuHeader: React.FC<IProps> = ({
  clearActionLabel,
  title,
  titleTriggerProps,
}) => {
  const { setOpen } = useFloatingContext();
  const { onClear } = useFilterMenuContext();

  return (
    <div className="fs-filter-menu__header">
      <div className="fs-filter-menu__title">
        <p className="type-fs-paragraph-medium">{title}</p>
        {titleTriggerProps ? (
          <ButtonBase
            type="button"
            className="fs-icon-button fs-icon-button--tertiary fs-icon-button--x-small fs-filter-menu__title-trigger"
            aria-label={titleTriggerProps["aria-label"]}
            onClick={titleTriggerProps.onClick}
          >
            <ButtonIcon
              Icon={Information}
              titleAccess=""
              className="fs-icon-button__icon"
            />
          </ButtonBase>
        ) : null}
      </div>
      {clearActionLabel !== undefined ? (
        <Button
          size="xSmall"
          variant="plain"
          onClick={() => {
            onClear?.();
            setOpen(false);
          }}
        >
          {clearActionLabel}
        </Button>
      ) : null}
    </div>
  );
};
